import { defineStore } from "pinia";
import Services from '@/services/statistic'

export const useStatisticStore = defineStore("statistic", {

state:()=>({
    counts : {},
    usersByRegions : [],
    personTypesByGovernorate : [],
    maritalByPersonTypesAndGovernorate : [],
    educationByPersonTypesAndGovernorate : [],
    ageByPersonTypesAndGovernorate : [],
    genderByPersonTypesAndGovernorate : [],
}),
getters : {
    getCounts() {
        return this.counts;
    },
    getUsersByRegions() {
        return this.usersByRegions;
    },
    getPersonTypesByGovernorate() {
        return this.personTypesByGovernorate;
    },
    getMaritalByPersonTypesAndGovernorate() {
        return this.maritalByPersonTypesAndGovernorate;
    },
    getEducationByPersonTypesAndGovernorate() {
        return this.educationByPersonTypesAndGovernorate;
    },
    getAgeByPersonTypesAndGovernorate() {
        return this.ageByPersonTypesAndGovernorate;
    },
    getGenderByPersonTypesAndGovernorate() {
        return this.genderByPersonTypesAndGovernorate;
    }
},
actions : {
    /** Start Sets */
    setCounts(counts) {
        this.counts = counts
    },
    setUsersByRegions(usersByRegions) {
        this.usersByRegions = usersByRegions
    },
    setPersonTypesByGovernorate(personTypesByGovernorate) {
        this.personTypesByGovernorate = personTypesByGovernorate
    },
    setMaritalByPersonTypesAndGovernorate(maritalByPersonTypesAndGovernorate) {
        this.maritalByPersonTypesAndGovernorate = maritalByPersonTypesAndGovernorate
    },
    setEducationByPersonTypesAndGovernorate(educationByPersonTypesAndGovernorate) {
        this.educationByPersonTypesAndGovernorate = educationByPersonTypesAndGovernorate
    },
    setAgeByPersonTypesAndGovernorate(ageByPersonTypesAndGovernorate) {
        this.ageByPersonTypesAndGovernorate = ageByPersonTypesAndGovernorate
    },
    setGenderByPersonTypesAndGovernorate(genderByPersonTypesAndGovernorate) {
        this.genderByPersonTypesAndGovernorate = genderByPersonTypesAndGovernorate
    },
    /** End Sets */

    /** Start Actions */
    getCountsStatistics(data) {
        return Services.getCountsStatistics(data)
        .then((response)=>{
            this.setCounts(response.data.data)
            return response
        })
    },
    getUsersByRegionsStatistic(data) {
        return Services.getUsersByRegions(data)
        .then((response)=>{
            this.setUsersByRegions(response.data)
            return response
        })
    },
    getPersonTypesByGovernorateStatistic(data) {
        return Services.getPersonTypesByGovernorate(data)
        .then((response)=>{
            const processedData = helperPersonTypesByGovernorate(response.data);
            this.setPersonTypesByGovernorate(processedData)
            return response
        })
    },
    getMaritalByPersonTypesAndGovernorateStatistic(data) {
        return Services.getMaritalByPersonTypesAndGovernorate(data)
        .then((response)=>{
            const processedData = appendGovernoratesTotal(response.data);
            this.setMaritalByPersonTypesAndGovernorate(processedData)
            return response
        })
    },
    getEducationByPersonTypesAndGovernorateStatistic(data) {
        return Services.getEducationByPersonTypesAndGovernorate(data)
        .then((response)=>{
            const processedData = appendGovernoratesTotal(response.data);
            this.setEducationByPersonTypesAndGovernorate(processedData)
            return response
        })
    },
    getAgeByPersonTypesAndGovernorateStatistic(data) {
        return Services.getAgeByPersonTypesAndGovernorate(data)
        .then((response)=>{
            const processedData = appendGovernoratesTotal(response.data);
            this.setAgeByPersonTypesAndGovernorate(processedData)
            return response
        })
    },
    getGenderByPersonTypesAndGovernorateStatistic(data) {
        return Services.getGenderByPersonTypesAndGovernorate(data)
        .then((response)=>{
            const processedData = appendGovernoratesTotal(response.data);
            this.setGenderByPersonTypesAndGovernorate(processedData)
            return response
        })
    },
    /** End Actions */
}
});

function appendGovernoratesTotal(data) {
  const totalsByPersonId = {};

  data.forEach((governorate) => {
    governorate.personType.forEach((person) => {
      const statsKey = Object.keys(person).find((key) => key.endsWith("Stats"));
      if (!statsKey) return;

      if (!totalsByPersonId[person.id]) {
        totalsByPersonId[person.id] = {
          id: person.id,
          name: person.name,
          [statsKey]: Object.keys(person[statsKey]).reduce((acc, key) => {
            acc[key] = 0;
            return acc;
          }, {}),
        };
      }

      Object.entries(person[statsKey]).forEach(([key, value]) => {
        totalsByPersonId[person.id][statsKey][key] += value || 0;
      });
    });
  });

  return [
    ...data,
    {
      id: 0,
      name: "المجموع",
      personType: Object.values(totalsByPersonId),
    },
  ];
}


function helperPersonTypesByGovernorate(data){
    const totalPersonType = Object.values(
        data.reduce((acc, item) => {
        item.personType.forEach((p) => {
            if (!acc[p.id]) {
            acc[p.id] = {
                id: p.id,
                name: p.name,
                count: 0,
            };
            }

            acc[p.id].count += p.count;
        });

        return acc;
        }, {})
    );

    data.push({
        id: 0,
        name: "المجموع",
        personType: totalPersonType,
    });

    return data;
}